import React from 'react';
import { Box } from '@mui/material';

export default function OutstandingPayablesCard() {
  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Outstanding Payables</h3>
      </div>
      <div id="finPayablesBreakdown" className="funnel" style={{ height: '220px', overflow: 'auto' }}>
        <div className="funnel-row" data-stage="due-today" onClick={(e) => window.finPayablesClick?.('due-today', e.currentTarget)}>
          <div className="funnel-label">Due today</div>
          <div className="funnel-bar-bg">
            <div className="funnel-bar inline-style-10" style={{ width: '13%' }}>₹0.72L</div>
          </div>
        </div>
        <div className="funnel-row" data-stage="due-7" onClick={(e) => window.finPayablesClick?.('due-7', e.currentTarget)}>
          <div className="funnel-label">{"Due < 7 days"}</div>
          <div className="funnel-bar-bg">
            <div className="funnel-bar inline-style-11" style={{ width: '33%' }}>₹1.98L</div>
          </div>
        </div>
        <div className="funnel-row" data-stage="due-30" onClick={(e) => window.finPayablesClick?.('due-30', e.currentTarget)}>
          <div className="funnel-label">Due 8\u201330 days</div>
          <div className="funnel-bar-bg">
            <div className="funnel-bar inline-style-15" style={{ width: '22%' }}>₹1.34L</div>
          </div>
        </div>
        <div className="funnel-row" data-stage="31-60" onClick={(e) => window.finPayablesClick?.('31-60', e.currentTarget)}>
          <div className="funnel-label">31\u201360 days</div>
          <div className="funnel-bar-bg">
            <div className="funnel-bar inline-style-16" style={{ width: '12%' }}>₹0.72L</div>
          </div>
        </div>
        <div className="funnel-row" data-stage="overdue" onClick={(e) => window.finPayablesClick?.('overdue', e.currentTarget)}>
          <div className="funnel-label">Overdue</div>
          <div className="funnel-bar-bg">
            <div className="funnel-bar inline-style-17" style={{ width: '100%' }}>₹7.24L</div>
          </div>
        </div>
      </div>
      <div className="legend-row">
        <span className="inline-style-35">₹13.03L total outstanding</span>
      </div>
    </Box>
  );
}
